import { cn } from '@cobliteam/ui/utils';

import { Analytics } from '@cobliteam/analytics';

import Button from '@cobliteam/ui/components/Button';
import Typography from '@cobliteam/ui/components/Typography';

const LoginMKT = () => {
  const handleClick = () => {
    Analytics.track('login_mkt_download_infographic');
    window.open('https://app.hubspot.com/documents/5282301/view/811194035?accessId=a31e7d', '_blank');
  };

  return (
    <div className='grid grid-cols-12 grid-rows-12'>
      <div
        className={cn(
          'col-span-12 row-span-6',
          'cursor-pointer bg-center bg-contain bg-secondary',
          "tablet:bg-[url('/static/images/login/tablet.jpg')]",
          "laptop:bg-[url('/static/images/login/desktop.jpg')]",
          "desktop:bg-[url('/static/images/login/desktop.jpg')]",
          "widescreen:bg-[url('/static/images/login/widescreen.jpg')]",
          "bg-[url('/static/images/login/desktop.jpg')]",
          'bg-[#001BB8]'
        )}
      />
      <div className='col-span-12 row-span-6 flex items-center justify-center bg-[#01137B] py-12'>
        <div className='w-full max-w-[320px] items-center text-pretty'>
          <Typography className='font-medium text-lg text-white leading-[118%]'> A central de regras personalizadas da sua operação</Typography>
          <Typography className='mt-6 font-normal text-lg text-white leading-[118%]'>Receba apenas notificações essenciais e ganhe em eficiência, controle e segurança.</Typography>
          <Button variant='contained' color='success' className='mt-6 w-36' asChild>
            <a href='https://www.youtube.com/watch?v=XIUJ4uyECWM' target='_blank' rel='noreferrer'>
              Entenda mais
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginMKT;
